import { createSvgIcon } from '@mui/material/utils';

export const CheckBoxUncheckedIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <path d="M19 5V19H5V5H19Z" fill="white" />
    <path
      d="M5 3.5H19C19.8239 3.5 20.5 4.17614 20.5 5V19C20.5 19.8239 19.8239 20.5 19 20.5H5C4.17614 20.5 3.5 19.8239 3.5 19V5C3.5 4.17614 4.17614 3.5 5 3.5ZM4.5 19.5H19.5V4.5H4.5V19.5Z"
      fill="#898F9B"
      stroke="#40444D"
    />
  </svg>,
  'CheckBoxUnchecked',
);
